import { render } from "./MyNotifications.vue?vue&type=template&id=7e54af90&scoped=true"
import script from "./MyNotifications.vue?vue&type=script&lang=js"
export * from "./MyNotifications.vue?vue&type=script&lang=js"

import "./MyNotifications.vue?vue&type=style&index=0&id=7e54af90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e54af90"]])

export default __exports__